module.exports = __webpack_public_path__ + "static/media/blaine-1.476eaccb.wav";